import { render } from "./License.vue?vue&type=template&id=0f200f85"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__